import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { jobFeedService } from "domain/service";
import JobFeed from "domain/model/JobFeed";
import { SubmitTypes } from "components/JobOffer/lib/JobOfferForm";
import { generatePath, useHistory } from "react-router-dom";
import routes from "utils/routes";
import { jobFeedRepository } from "domain/repository";
import { JobFeedForm } from "components/JobFeed/JobFeedForm";

type Props = {
  isAgency: boolean;
  storeId: string | undefined;
  id: string;
};

export const EditForm: React.FC<Props> = ({ isAgency, storeId, id }) => {
  const [jobFeed, setJobFeed] = useState<JobFeed | null>(null);
  const history = useHistory();

  useEffect(() => {
    jobFeedService
      .fetchJobFeed(isAgency, storeId, id)
      .then((res) => setJobFeed(res));
  }, [id, isAgency, storeId]);

  if (jobFeed === null) {
    return <Loader active />;
  }

  const {
    url,
    title,
    company,
    jobType,
    description,
    postDate,
    salaryType,
    salaryMin,
    salaryMax,
    state,
    city,
    address,
    station,
    experience,
    workingTime,
    imageUrl,
  } = jobFeed;

  return (
    <JobFeedForm
      initialValues={{
        url,
        title,
        company,
        jobType,
        description,
        postDate,
        salaryType,
        salaryMin,
        salaryMax,
        state,
        city,
        address,
        station,
        experience,
        workingTime,
        imageUrl,
      }}
      isAgency={isAgency}
      storeId={storeId}
      handleSubmit={({ values, setStatus, resetForm }) => {
        jobFeedRepository
          .update(isAgency, storeId, id, values)
          .then(() => {
            resetForm();
            const jobFeedIndex = isAgency
              ? generatePath(routes.agency.jobFeedIndex.pathname, {
                  storeId,
                })
              : routes.store.jobFeedIndex;
            history.push(jobFeedIndex);
          })
          .catch((e) => {
            if (e.response.status === 422) {
              setStatus({ success: "", error: e.response.data.message });
            } else {
              setStatus({ success: "", error: "更新に失敗しました" });
            }
          });
      }}
      submitType={SubmitTypes.UPDATE}
    />
  );
};
